import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../../api";

const CompanyContext = createContext({
  company: { name: "", slogan: "", email: "", phone: "", address: "", city: "", zip: "" },
  pdfAccentColor: "#33BBFF",
  prestationTypes: ["Déménagement", "Garde-meuble", "Montage/Démontage", "Transport"],
  paymentMethods: ["Virement", "Chèque", "Espèces", "CB", "Prélèvement"],
  teamLeaders: [],
  logoPath: null,
  vatRate: 0.2,
  quoteValidityDays: 30,
  quotePrefix: "DEV",
  invoicePrefix: "FAC",
  loading: true,
  reload: () => {},
});

export function CompanyProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading]   = useState(true);

  async function fetchSettings() {
    try {
      const { data } = await api.get("/settings/public");
      setSettings(data);
      // Apply accent color as CSS custom property
      if (data?.pdfAccentColor) {
        document.documentElement.style.setProperty("--brand-accent", data.pdfAccentColor);
      }
      // Update page title
      if (data?.company?.name) {
        document.title = data.company.name;
      }
    } catch {
      // silent — fallback defaults remain
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchSettings(); }, []);

  const value = {
    company:          settings?.company          ?? { name: "", slogan: "", email: "", phone: "", address: "", city: "", zip: "" },
    pdfAccentColor:   settings?.pdfAccentColor   ?? "#33BBFF",
    prestationTypes:  settings?.prestationTypes  ?? ["Déménagement", "Garde-meuble", "Montage/Démontage", "Transport"],
    paymentMethods:   settings?.paymentMethods   ?? ["Virement", "Chèque", "Espèces", "CB", "Prélèvement"],
    teamLeaders:      settings?.teamLeaders      ?? [],
    logoPath:         settings?.logoPath         ?? null,
    vatRate:          settings?.vatRate          ?? 0.2,
    quoteValidityDays:settings?.quoteValidityDays?? 30,
    quotePrefix:      settings?.quotePrefix      ?? "DEV",
    invoicePrefix:    settings?.invoicePrefix    ?? "FAC",
    loading,
    reload: fetchSettings,
  };

  return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
}

export function useCompany() {
  return useContext(CompanyContext);
}

export default CompanyContext;
